/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CreateProjectComponent } from './create-project/create-project.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectListComponent } from './project-list/project-list.component';
import { TabsModule} from 'ngx-bootstrap/tabs';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AddUsersComponent } from './add-users/add-users.component';
import { ProjectDetailsInfoComponent } from './project-details-info/project-details-info.component';
import { FilterSearchResultsComponent } from './filter-search-results/filter-search-results.component';
import { ProjectCreateSearchComponent } from './project-create-search/project-create-search.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SliderComponent } from './slider/slider.component';
import { GenerateReportComponent } from './generate-report/generate-report.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AddLineItemComponent } from './add-line-item/add-line-item.component'; 
import {SharedModule} from '../../shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatDialogModule } from "@angular/material/dialog";
// import { NgxCurrencyModule } from 'ngx-currency';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { GenerateFinancialNotesComponent } from './generate-financial-notes/generate-financial-notes/generate-financial-notes.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { ToolDisclaimerComponent } from './tool-disclaimer/tool-disclaimer.component';
import { FormeightkViewerComponent } from './formeightk-viewer/formeightk-viewer.component';
import { DialogModule, TabsModule as tdsTabsModule, ButtonModule, CheckBoxModule, TextInputModule, IconModule, PopoverModule } from '@kpmg-ux/ngx-tax-design-system';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [CreateProjectComponent, ProjectListComponent, AddUsersComponent, 
    ProjectDetailsInfoComponent, FilterSearchResultsComponent,
     ProjectCreateSearchComponent, SliderComponent, GenerateReportComponent, AddLineItemComponent, GenerateFinancialNotesComponent, ToolDisclaimerComponent, FormeightkViewerComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTableModule,MatSortModule,MatCheckboxModule,
    FormsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    DialogModule,
    NgMultiSelectDropDownModule,
    MatDialogModule,
    MatTooltipModule,
    // NgxCurrencyModule,
    AngularMultiSelectModule,
    // other imports
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ButtonModule,
    TextInputModule,
    IconModule,
    tdsTabsModule,
    PopoverModule,
    CheckBoxModule
  ],
  providers: [DatePipe],
  exports: [CreateProjectComponent, ProjectListComponent, ProjectDetailsInfoComponent, 
    AddUsersComponent, FilterSearchResultsComponent,ProjectCreateSearchComponent, SliderComponent,
    AddLineItemComponent,GenerateFinancialNotesComponent,ToolDisclaimerComponent, FormeightkViewerComponent]
})
export class ProjectSharedModule { }
